import { render } from "./VentanaAjustes.vue?vue&type=template&id=2a51081e&scoped=true"
import script from "./VentanaAjustes.vue?vue&type=script&lang=js"
export * from "./VentanaAjustes.vue?vue&type=script&lang=js"

import "./VentanaAjustes.vue?vue&type=style&index=0&id=2a51081e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a51081e"]])

export default __exports__